import { Link } from "react-router-dom";

export const Logo = ({ className = "h-7", onClick }) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="adinvo-logo"
      className="inline-flex select-none items-center"
    >
      <img
        src="/adinvo-logo.png"
        alt="Adinvo"
        className={`${className} w-auto`}
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
